module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "content-class": "addToPlaylist-dialog"
    },
    model: {
      value: (_vm.getAddToPlaylist),
      callback: function($$v) {
        _vm.getAddToPlaylist = $$v
      },
      expression: "getAddToPlaylist"
    }
  }, [_c('v-icon', {
    staticClass: "icon-close",
    on: {
      "click": function($event) {
        _vm.closeAddToPlaylist()
      }
    }
  }, [_vm._v("close")]), _vm._v(" "), (!_vm.newPlaylistActive && !_vm.playlistAddedSuccess) ? _c('div', {
    staticClass: "addToPlaylist"
  }, [_c('div', {
    staticClass: "text-center _top"
  }, [_c('span', [_vm._v("Add To Playlist")])]), _vm._v(" "), _c('div', {
    staticClass: "mb-3 app-bold"
  }, [_vm._v("All to Playlists")]), _vm._v(" "), _c('div', {
    staticClass: "mb-2 _playlist add_new",
    on: {
      "click": function($event) {
        _vm.newPlaylist()
      }
    }
  }, [_c('trackcardsimple', {
    attrs: {
      "item": {},
      "cover": require('@/assets/ic_add_to.png'),
      "title": "New Playlist",
      "coverRadius": ""
    }
  })], 1), _vm._v(" "), _vm._l((this.playlists), function(playlist, index) {
    return ((_vm.selectedItems.length > 0)) ? _c('div', {
      key: index,
      staticClass: "mb-2 _playlist",
      on: {
        "click": function($event) {
          _vm.addToExistingPlaylist(playlist)
        }
      }
    }, [_c('trackcardsimple', {
      attrs: {
        "item": {},
        "cover": require('@/assets/playlist-grey.svg'),
        "title": playlist.name,
        "id": playlist.id,
        "coverRadius": ""
      }
    })], 1) : _vm._e()
  })], 2) : _vm._e(), _vm._v(" "), (_vm.newPlaylistActive) ? _c('div', {
    staticClass: "newPlaylist"
  }, [_c('div', {
    staticClass: "text-center _top",
    on: {
      "click": function($event) {
        _vm.createNewPlaylist()
      }
    }
  }, [_c('span', [_vm._v("New Playlist")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPlaylistTitle),
      expression: "newPlaylistTitle"
    }],
    attrs: {
      "type": "text",
      "name": "newPlaylist",
      "id": "newPlaylist",
      "placeholder": "Name your playlist"
    },
    domProps: {
      "value": (_vm.newPlaylistTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPlaylistTitle = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dflex justify-space-between align-center"
  }, [_c('div', {
    staticClass: "app-bold my-3"
  }, [_vm._v("Playlist is public")]), _vm._v(" "), _c('v-switch', {
    staticClass: "flex-none widthfit",
    attrs: {
      "color": "green",
      "hide-details": ""
    },
    model: {
      value: (_vm.isNewPlaylistPublic),
      callback: function($$v) {
        _vm.isNewPlaylistPublic = $$v
      },
      expression: "isNewPlaylistPublic"
    }
  })], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('v-btn', {
    staticClass: "py-4",
    attrs: {
      "round": "",
      "dark": "",
      "block": ""
    },
    on: {
      "click": function($event) {
        _vm.addNewPlaylist()
      }
    }
  }, [_vm._v("\n      Save Playlist\n    ")])], 1) : _vm._e(), _vm._v(" "), (_vm.playlistAddedSuccess) ? _c('div', {
    staticClass: "text-center playlistAddedSuccess"
  }, [_c('img', {
    attrs: {
      "src": require('@/assets/playlist-grey.svg'),
      "width": "50",
      "alt": "playlist icon"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "intro-text"
  }, [_vm._v("Added to Playlist")]), _vm._v(" "), _c('div', {
    staticClass: "body-text"
  }, [_vm._v("\n      " + _vm._s(_vm.selectedItems.length) + " " + _vm._s(_vm._f("pluralize")(_vm.type, _vm.selectedItems.length)) + " added to \"" + _vm._s(_vm.newPlaylistTitle) + "\"\n    ")])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-440bbcc5","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Playlists/addToPlaylist.vue
// module id = 1702
// module chunks = 180